import styleInject from 'style-inject';

var css_248z = ".Checkbox-module_input__AqNnN{cursor:pointer;height:var(--size-0);width:var(--size-0)}.Checkbox-module_label__s3VhF{cursor:pointer}";
var styles = {"input":"Checkbox-module_input__AqNnN","label":"Checkbox-module_label__s3VhF"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2hlY2tib3gubW9kdWxlLnNjc3MuanMiLCJzb3VyY2VzIjpbXSwic291cmNlc0NvbnRlbnQiOltdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7OzsifQ==
